import { render, staticRenderFns } from "./DeleteBatchNo.vue?vue&type=template&id=5a316c44&scoped=true&"
import script from "./DeleteBatchNo.vue?vue&type=script&lang=js&"
export * from "./DeleteBatchNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a316c44",
  null
  
)

export default component.exports